import { z } from 'zod';
/** A 24-character hex Mongo ObjectId, as it appears over the wire. */
export const objectIdSchema = z
    .string()
    .regex(/^[0-9a-fA-F]{24}$/, 'must be a 24-character hex id');
/**
 * An instant in time. Accepts an ISO-8601 string or an epoch-millisecond
 * number and always yields a `Date`, so route handlers never see raw strings.
 */
export const instantSchema = z.coerce.date();
/** A calendar day in the user's own timezone, e.g. "2026-08-16". */
export const localDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'must be a YYYY-MM-DD date');
/**
 * A client-generated id that makes one write safe to replay.
 *
 * The offline queue exists because a write can be composed while unreachable,
 * and the hard part of replaying it later is not sending it — it is knowing
 * whether the *first* attempt landed. A request whose response was lost in
 * flight is indistinguishable, from the client, from one that never arrived.
 * With this the server can tell them apart, and answer a repeat with the
 * original result instead of logging breakfast twice.
 */
export const clientRequestIdSchema = z
    .string()
    .trim()
    .min(8)
    .max(100)
    .regex(/^[A-Za-z0-9_-]+$/, 'must be url-safe');
export const paginationSchema = z.object({
    limit: z.coerce.number().int().min(1).max(200).default(50),
    offset: z.coerce.number().int().min(0).default(0),
});
export const idParamSchema = z.object({ id: objectIdSchema });
/** IANA timezone name. Validated against the runtime's own tz database. */
export const timezoneSchema = z.string().refine((value) => {
    try {
        new Intl.DateTimeFormat('en-US', { timeZone: value });
        return true;
    }
    catch {
        return false;
    }
}, 'must be a valid IANA timezone');
export const localeSchema = z.enum(['de', 'en']);
/** Shape every error response uses, so the PWA has one thing to parse. */
export const apiErrorSchema = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
        details: z.unknown().optional(),
    }),
});
//# sourceMappingURL=common.js.map